/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

interface SearchApiUrlOptions {
	serverUrl?: string;
	siteBasePath?: string;
	fallbackOrigin: string;
}

export const getSearchApiUrl = (params: URLSearchParams, options: SearchApiUrlOptions): URL => {
	const origin = (options.serverUrl || options.fallbackOrigin).replace(/\/+$/, "");
	const siteBasePath = options.siteBasePath ? `/${options.siteBasePath.replace(/^\/+|\/+$/g, "")}` : "";

	return new URL(`${origin}${siteBasePath}/api/cosmos/search?${params.toString()}`);
};
